import { getHubWeekly, projectIdsKey } from "../data/projectHubClient.js";
import { isMondayIso } from "../data/projectWeeklyClient.js";
import { getWeeklyEvidence, loadWeeklyEvidence, weeklyEvidenceKey } from "./projectWeeklyCache.js";

export function weeklyCountsSnapshot(ids, authIdentity, week) {
  return getWeeklyEvidence(weeklyEvidenceKey(projectIdsKey(ids), authIdentity, week), true);
}
export function readWeeklyCounts(ids, authIdentity, week) {
  const key = weeklyEvidenceKey(projectIdsKey(ids), authIdentity, week);
  return loadWeeklyEvidence(key, async () => {
    // Omitting weekDate uses the existing server-owned current Monday.
    let data = await getHubWeekly(ids, week ? { weekDate: week } : {});
    // A query can cross UTC Monday. Re-read the current aggregate instead of
    // labeling the previous week's decisions as current.
    if (data?.currentWeek && data.currentWeek !== data.weekDate) data = await getHubWeekly(ids, {});
    if (!isMondayIso(data?.weekDate) || (week && data.weekDate !== week)
      || (data.currentWeek && (!isMondayIso(data.currentWeek) || data.currentWeek !== data.weekDate))
      || !["posted", "eligible", "decisionsDue"].every(k => Number.isFinite(data[k]))) {
      throw new Error("Weekly counts did not match the current week. Please retry.");
    }
    return data;
  });
}
